import React from 'react';
import { Link } from 'react-router-dom';

import {
  Box,
  Button,
  ButtonBase,
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as Checked } from '../../../../../../assets/img/Checked.svg';
import SubHeader from '../../../../../../components/Header/SubHeader.component';
import Loader from '../../../../../../components/LoaderSplash/Loader.component';

const useStyle = makeStyles((theme: Theme) => createStyles({}));

const PhotographicInspection = () => {
  const classes = useStyle();

  return (
    <>
      {/* <Box display={loading ? 'block' : 'none'}>
                <Loader action={'Cargando denuncias'}></Loader>
            </Box> */}

      <SubHeader
        content={
          <Box>
            <Typography variant="h6">Inspección fotográfica</Typography>
          </Box>
        }
      ></SubHeader>

      <Grid container justify="center">
        <Grid item xs={11}>
          <Box my={4}>
            <Typography variant="h6">
              Para evaluar los daños de tu vehículo debemos inspeccionarlo por
              foto
            </Typography>
          </Box>
          <Box my={2}>
            <Typography>
              Para ello, coordina turno en alguno de nuestros talleres y subí
              las fotos en el siguiente enlace:
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid
          item
          xs={11}
          style={{
            display: 'flex',
            marginTop: '1rem',
            marginBottom: '1rem',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            href="https://sec-ar.controlexpert.com/apps/galicia.pm/#!/asm/"
            target="_blank"
          >
            Abrir enlace
          </Button>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item xs={11}>
          <Box mt={2} mb={3} style={{ display: 'flex' }}>
            <Box>
              <Checked></Checked>
            </Box>
            <Box style={{ marginLeft: '5px' }}>
              <Typography>¡Ahorra tiempo!</Typography>
            </Box>
          </Box>
          <Box my={2}>
            <Typography>
              Elegí un taller de gestión rápida, carga fotos de los daños, y
              acércate el día de tu turno para la reparación.
            </Typography>
          </Box>
          <Box my={2}>
            <Typography>
              Disponiendo en todo momento de tu vehículo, si cuenta con
              movilidad propia hasta la fecha de reparación.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default PhotographicInspection;
